<template>
  <div>
    <div v-if="serp === false">
      <div style="max-width: 300px; margin: auto; text-align: center; margin-top: 100px; margin-bottom: 100px;">
        <div class="text-h4 mb-4 grey--text">:(</div>
        <div class="text-h6 mb-12 font-weight-light grey--text">{{ $t('day-no-data') }}</div>
        <p class="grey--text">{{ $t('keyword-no-data') }}</p>
      </div>
    </div>
    <div v-else-if="!serp" class="mt-4">
      <div v-for="index in 30" :key="index" class="mb-2" style="display: flex;">
        <v-skeleton-loader class="mr-2" type="text" width="40"></v-skeleton-loader>
        <v-skeleton-loader v-if="skeletonNoComparison !== true" class="mr-2" type="text" width="40"></v-skeleton-loader>
        <v-skeleton-loader :width="Math.random() * 300 + 100" type="text"></v-skeleton-loader>
      </div>
    </div>
    <div v-else>
      <div v-if="visibleGlobalItems.length > 0" class="mt-4 mb-4">
        Blocs spéciaux :
        <span v-for="(item, i) in visibleGlobalItems" :key="item.type+i">
        <serp-dialog-detail-table-items :item="item"></serp-dialog-detail-table-items>
      </span>
      </div>

      <v-simple-table class="pi-4 hi-26 serp-dialog-table" dense style="width: 100%">
        <template v-slot:default>
          <tbody>

          <tr v-for="(item, i) in visibleItems" :key="'i'+i" :class="getColorForitem(item) + ' lighten-5'">
            <td class="text-right smallest">
              <strong v-if="item.position && isItemMatch(item)" :class="getColorForitem(item) + '--text'">
                {{ item.position }}.
              </strong>
              <span v-else-if="item.position">{{ item.position }}.</span>
            </td>

            <td v-if="comparison" class="smallest">
              <span v-if="item.variation > 0" class="success--text">
                <v-icon color="success" small>mdi-plus</v-icon> {{ Math.abs(item.variation) }}
              </span>
              <span v-else-if="item.variation < 0" class="error--text">
                <v-icon color="error" small>mdi-minus</v-icon> {{ Math.abs(item.variation) }}
              </span>
              <span v-else-if="item.variation === null" class="success--text font-weight-bold">
                NEW
              </span>
            </td>

            <td>
              <serp-dialog-detail-table-items :item="item"></serp-dialog-detail-table-items>
            </td>
          </tr>
          <tr v-for="(item, i) in comparisonOutItems" :key="'o'+i" :class="getColorForitem(item) + ' lighten-5'">
            <td class="smallest">+30.</td>

            <td class="smallest font-weight-bold error--text">
              OUT
            </td>

            <td>
              <serp-dialog-detail-table-items :item="item"></serp-dialog-detail-table-items>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import SerpDialogDetailTableItems from '@/views/Common/Components/SerpDetail/SerpDetailTableItems'

export default {
  name: 'SerpDialogDetailTable',
  components: {SerpDialogDetailTableItems},
  props: ['serp', 'comparison', 'skeletonNoComparison'],
  computed: {
    items() {
      return this.serp.items()
    },
    matches() {
      return this.serp.matches()
    },
    visibleGlobalItems() {
      return this.items.filter(item => {
        return item.type === 'knowledge_graph'
      })
    },
    visibleItems() {
      const domainOffsets = {}

      return this.items.filter(item => {
        if (this.$account.isAdministrator) {
          return item.type !== 'hidden'
        } else {
          return item.type !== 'hidden' && item.type !== 'unknown'
        }
      }).map(item => {
        let variation = undefined

        if (this.comparison && item.type === 'organic') {
          const domain = (new URL(item.meta.link)).hostname

          if (!(domain in domainOffsets)) domainOffsets[domain] = 0
          else domainOffsets[domain]++

          variation = this.getItemVariation(item, this.comparison.items(), domainOffsets[domain])
        }

        return {...item, variation}
      })
    },
    comparisonOutItems() {
      if (!this.comparison) return []

      return this.comparison.items().filter(item => {
        if (item.type !== 'organic') {
          return false
        }

        const found = this.items.find(compItem => {
          return compItem.meta.link === item.meta.link
        })

        return !found
      })
    }
  },
  methods: {
    getColorForitem(item) {
      if (item.type === 'organic' && this.isItemMatch(item)) {
        /*
        if (item.position === null) return 'red'
        if (item.position === 1) return 'green'
        if (item.position === 2) return 'light-green'
        if (item.position === 3) return 'lime'
        if (item.position < 10) return 'orange'
        */
        return 'blue'
      } else {
        return ''
      }
    },
    getItemVariation(item, items, searchOffset) {
      let variation = null
      let currentOffset = 0

      items.forEach(cItem => {
        if (cItem.type === 'organic') {
          try {
            const domain1 = (new URL(item.meta.link)).hostname
            const domain2 = (new URL(cItem.meta.link)).hostname

            if (domain1 === domain2) {
              if (currentOffset === searchOffset) {
                variation = (item.position - cItem.position) * -1
              }
              currentOffset++
            }
          } catch (e) {
          }
        }
      })

      return variation
    },
    isItemMatch(item) {
      if (this.matches && item.type === 'organic') {
        return Object.keys(this.matches.positions).map(position => parseInt(position)).includes(parseInt(item.position))
      } else {
        return false
      }
    }
  }
}
</script>

<style>
.serp-dialog-table .v-data-table__wrapper {
  overflow-x: hidden !important;
}

.serp-dialog-table > .v-data-table__wrapper > table > tbody > tr > td {
  border-bottom: none !important;
}

.serp-dialog-table td.smallest {
  width: 1%;
  white-space: nowrap;
}
</style>

<i18n>
{
  "en": {
    "day-no-data": "No data to display for this day.",
    "keyword-no-data": "It is possible that this keyword has not been updated on this date, or that the information has not yet been loaded."
  },
  "es": {
    "day-no-data": "No hay datos para mostrar para este día.",
    "keyword-no-data": "Es posible que esta palabra clave no se haya actualizado en esta fecha, o que la información aún no se haya cargado."
  },
  "fr": {
    "day-no-data": "Aucune donnée à afficher pour cette journée.",
    "keyword-no-data": "Il est possible que ce mot clé n'ait pas été actualisé à cette date, ou que les informations ne soient pas encore chargées."
  },
  "it": {
    "day-no-data": "Nessun dato da visualizzare per questo giorno.",
    "keyword-no-data": "È possibile che questa parola chiave non sia stata aggiornata in questa data, o che le informazioni non siano ancora state caricate."
  },
  "pt": {
    "day-no-data": "Não há dados a exibir para este dia.",
    "keyword-no-data": "É possível que esta palavra-chave não tenha sido atualizada nesta data, ou que as informações ainda não tenham sido carregadas."
  },
  "pl": {
    "day-no-data": "Brak danych do wyświetlenia na ten dzień.",
    "keyword-no-data": "Możliwe, że to słowo kluczowe nie zostało zaktualizowane w tej dacie lub informacje nie zostały jeszcze załadowane."
  }
}
</i18n>